import { MotionPathPlugin } from "gsap/dist/MotionPathPlugin";
import { MorphSVGPlugin } from "gsap/dist/MorphSVGPlugin";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/dist/DrawSVGPlugin";
import { CSSRulePlugin } from "gsap/dist/CSSRulePlugin";
import { CustomEase } from "gsap/dist/CustomEase";
import { SplitText } from "gsap/dist/SplitText";
import { TextPlugin } from "gsap/dist/TextPlugin";
import gsap from "gsap";

gsap.registerPlugin(
  CSSRulePlugin,
  ScrollTrigger,
  SplitText,
  DrawSVGPlugin,
  MorphSVGPlugin,
  CustomEase,
  MotionPathPlugin,
  TextPlugin,
);

export { CSSRulePlugin, gsap, ScrollTrigger, SplitText, CustomEase, MotionPathPlugin, TextPlugin };
